import React, {useState, useEffect} from 'react';
// import {  EmailShareButton, FacebookShareButton, InstapaperShareButton, LineShareButton, LinkedinShareButton, LivejournalShareButton, MailruShareButton, OKShareButton, PinterestShareButton, PocketShareButton, RedditShareButton, TelegramShareButton, TumblrShareButton, TwitterShareButton, ViberShareButton, VKShareButton, WhatsappShareButton, WorkplaceShareButton, } from "react-share";
// import { FacebookIcon, TwitterIcon, TelegramIcon, WhatsappIcon, GooglePlusIcon, LinkedinIcon, PinterestIcon, VKIcon, OKIcon, RedditIcon, TumblrIcon, LivejournalIcon, MailruIcon, ViberIcon, WorkplaceIcon, EmailIcon, } from 'react-share';
import {LinkedinShareButton, LinkedinIcon} from 'react-share';
import {FacebookShareButton, FacebookIcon} from 'react-share';
import {TwitterShareButton, TwitterIcon} from 'react-share';
import {PinterestShareButton, PinterestIcon} from 'react-share';
import {EmailShareButton, EmailIcon} from 'react-share';
import CopyToClipboard from 'react-copy-to-clipboard';
import IconButton from '@mui/material/IconButton';
import LinkIcon from '@mui/icons-material/Link';
import {useRecoilValue, useSetRecoilState} from 'recoil';
import {userState} from '../recoil/user/userAtom';
import {theme} from '../Theme';
import {snackBarState} from '../recoil/snackBar/snackBarAtom';

const SharingList = (props: $TSFixMe) => {
  const user = useRecoilValue(userState);
  const [url, setUrl] = useState(props.url);
  const setSnackBar = useSetRecoilState(snackBarState);

  useEffect(() => {
    if (user?.code && !props.bidmiiPro) {
      setUrl(`${url}?r=${user.code}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const extractContent = (s: $TSFixMe) => {
    const span = document.createElement('span');
    span.innerHTML = s;
    return span.textContent || span.innerText;
  };

  const handleOnClickLink = () => {
    setSnackBar('Copied!');
  };

  const handleClick = (event: $TSFixMe) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div className="social-share-icons" onClick={handleClick}>
      <FacebookShareButton
        url={url}
        quote={extractContent(props.quote)}
        onShareWindowClose={props.onShareWindowClose}>
        <FacebookIcon size={40} round={true} />
      </FacebookShareButton>

      <TwitterShareButton
        url={url}
        onShareWindowClose={props.onShareWindowClose}>
        <TwitterIcon size={40} round={true} />
      </TwitterShareButton>

      <LinkedinShareButton
        url={url}
        summary={extractContent(props.quote)}
        source="Bidmii"
        onShareWindowClose={props.onShareWindowClose}>
        <LinkedinIcon size={40} round={true} />
      </LinkedinShareButton>

      {props.media && (
        <PinterestShareButton
          url={url}
          media={props.media}
          onShareWindowClose={props.onShareWindowClose}>
          <PinterestIcon size={40} round={true} />
        </PinterestShareButton>
      )}

      <EmailShareButton
        subject="Check out this project on Bidmii!"
        body="Here's another great project I thought you might be interested in"
        url={url}>
        <EmailIcon size={40} round={true} />
      </EmailShareButton>

      <CopyToClipboard text={url}>
        <IconButton
          style={{color: theme.palette.gray.dark}}
          onClick={handleOnClickLink}
          size="large">
          <LinkIcon />
        </IconButton>
      </CopyToClipboard>
    </div>
  );
};

export default SharingList;
